import React, { useState } from "react";
import { darken, lighten } from "polished";
import {
  Grid,
  TextField,
  Button,
  Menu,
  MenuItem,
  Paper,
  Fade,
  Typography,
  Box,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import EditIcon from "@mui/icons-material/Edit";
import UserAddModal from "./subUserProcess";
import SubUserProcess from "./subUserProcess";
import Swal from "sweetalert2";

const UserOperationsMenu = ({ selectedUser, taxpayerList, search }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action) => {
    if (action === "add") {
      setAddModalOpen(true);
    } else if (action === "update") {
      if (!selectedUser || selectedUser.length === 0) {
        Swal.fire({
          text: "Lütfen bir kullanıcı Seçiniz",
          icon: "info",
          confirmButtonText: "TAMAM",
        });
        return;
      }
      setEditModalOpen(true);
    }
    handleClose();
  };

  return (
    <Grid
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Button
        id="operations-button"
        aria-controls={open ? "operations-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          textTransform: "none",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          backgroundColor: "#7367f0",
          height: "40px",
          minWidth: "130px",
          boxShadow: "0 2px 4px rgba(115,103,240,0.3)",
          "&:hover": {
            backgroundColor: darken(0.1, "#7367f0"),
            boxShadow: "0 4px 8px rgba(115,103,240,0.5)",
          },
          "& .MuiButton-endIcon": {
            marginLeft: "auto",
            transition: "transform 0.3s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          },
        }}
        variant="contained"
        endIcon={<KeyboardArrowDownIcon />}
      >
        <Typography fontWeight="medium">İşlemler</Typography>
      </Button>

      <Menu
        id="operations-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        transitionDuration={250}
        MenuListProps={{
          "aria-labelledby": "operations-button",
          sx: { padding: "4px" },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 6,
          sx: {
            minWidth: "220px",
            borderRadius: "8px",
            mt: 0.5,
            overflow: "visible",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: -5,
              right: 20,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => handleMenuItemClick("add")}
          sx={{
            borderRadius: "4px",
            m: 0.5,
            py: 1,
            "&:hover": {
              backgroundColor: "rgba(115, 103, 240, 0.08)",
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <PersonAddIcon sx={{ mr: 1.5, color: "#7367f0" }} />
            <Typography>Kullanıcı Ekle</Typography>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => handleMenuItemClick("update")}
          sx={{
            borderRadius: "4px",
            m: 0.5,
            py: 1,
            "&:hover": {
              backgroundColor: "rgba(115, 103, 240, 0.08)",
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <EditIcon sx={{ mr: 1.5, color: "#7367f0" }} />
            <Typography>Kullanıcı Güncelle</Typography>
          </Box>
        </MenuItem>
      </Menu>
      {addModalOpen && (
        <SubUserProcess
          open={addModalOpen}
          onClose={() => setAddModalOpen(false)}
          process="add"
          taxpayerList={taxpayerList}
          search={search}
        />
      )}
      {editModalOpen && (
        <SubUserProcess
          open={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          process="update"
          userData={selectedUser}
          taxpayerList={taxpayerList}
          search={search}
        />
      )}
    </Grid>
  );
};

export default UserOperationsMenu;
